import { Box, Form, Loader, ModBox, Text } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../../data/store'
import { accountSummaryForm } from './formData'
const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const AccountSummary = ({ selectedEntity }: any) => {
  const { getSummaryData, isSyncDone, getAccountSummaryDataForMakerChecker, fetchAllLovs, fetchMccProgramDetails } =
    useStores((root) => ({
      getSummaryData: root.getAccountSummaryData,
      isSyncDone: root.onboarding.isSyncDone,
      getAccountSummaryDataForMakerChecker: root.getAccountSummaryDataForMakerChecker,
      fetchAllLovs: root.fetchAllLovs,
      fetchMccProgramDetails: root.fetchMccProgramDetails,
    }))

  const [data, setData] = useState({})
  const [getAllLovs, getSingleLovHandler] = useLazyApiData(fetchAllLovs)
  const [fetchMccProgramDetailsApi, { state, data: apiData }] = useLazyApiData(fetchMccProgramDetails)

  const isFocused = useIsFocused()
  useEffect(() => {
    if (isFocused) {
      const masKeysArray1 = ['Status', 'Gender', 'BusinessChannel', 'State', 'YearsInBusiness', 'TerminalStatus']
      getAllLovs(...masKeysArray1)
    }
  }, [getAllLovs, isFocused])

  useEffect(() => {
    if (getSingleLovHandler?.state === 'fulfilled' || getSingleLovHandler?.state === 'rejected') {
      const mData =
        selectedEntity && selectedEntity?.applicationId?.length > 0
          ? getAccountSummaryDataForMakerChecker(selectedEntity)
          : getSummaryData(selectedEntity?.id)
      setData(mData)
      console.log('AccountSummary: ', mData)
      if (mData?.mccCode?.length > 0 && mData?.mccCode?.length < 5) {
        fetchMccProgramDetailsApi(mData?.mccCode)
      }
    }
  }, [
    getSummaryData,
    selectedEntity?.id,
    isSyncDone,
    selectedEntity,
    getAccountSummaryDataForMakerChecker,
    getSingleLovHandler?.state,
    fetchMccProgramDetailsApi,
  ])

  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40} backgroundColor={'WHITE'} nativeID="vertical-scroll">
      <ModBox show={getSingleLovHandler?.state === 'pending' || state === 'pending'}>
        <Loader />
      </ModBox>
      <ModBox show={getSingleLovHandler?.state !== 'pending' && state !== 'pending'}>
        <Box direction="row" w={'100%'} justifyContent={'space-between'}>
          <Box direction="row">
            <Text title={'Account Summary'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          </Box>
        </Box>
        <ModBox marginTop={40}>
          <Form
            formData={accountSummaryForm(false)}
            actionButtons={() => <></>}
            initialValues={{
              gender: data?.gender,
              firstName: data?.firstName,
              lastName: data?.lastName,
              dob: data?.dateOfBirth,
              businessDisplayName: data?.businessDisplayName,
              entityPanNumber: data?.entityPanNumber,
              businessChannel: data?.businessChannel,
              businessLine: apiData?.businessLine ?? 'NA',
              lineOfBusiness: data?.lineOfBusiness,
              mobileNumber: data?.mobileNumber,
              emailId: data?.emailId,
              webAddress: data?.webAddress,
              addressLine1: data?.addressLine1,
              addressLine2: data?.addressLine2,
              city: data?.city,
              state: data?.state,
              pincode: data?.pincode,
              country: data?.country,
              status: data?.status,
              storeCode: data?.storeCode,
              format: data?.format,
            }}
            container={FormBox}
          />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { AccountSummary }
